module.exports = __webpack_public_path__ + "img/other.d16b4d04.svg";